<div class="similar-events-carousel">
  <ion-title class="ion-padding">{{title}}</ion-title>
  <ion-slides class="padl10" pager="true" [options]="slideOpts">
    <ion-slide *ngFor="let item of eventsList">
      <div  routerLink="/event/{{item.id}}" routerDirection="forward">
        <ion-card>
          <img [src]="item?.img" />
        </ion-card>
        <div >
          <ion-card-subtitle class="ion-text-start padl10">{{item?.title}}</ion-card-subtitle>
        </div>
      </div>
    </ion-slide>
  </ion-slides>
</div>